// 標準レポート
const StandardReport = () => {
  return import('@/pages/Advertiser/Report/StandardReport')
}
// 予算進捗
const BudgetProgress = () => {
  return import('@/pages/Advertiser/Report/BudgetProgressReport')
}
// レポート出力
const IntervalReport = () => {
  return import('@/pages/Advertiser/Report/IntervalReport')
}
// マップレポート申請
const MapReportRequest = () => {
  return import('@/pages/Advertiser/Report/MapReportRequest')
}
// マップレポート
const MapReport = () => {
  return import('@/pages/Advertiser/Report/MapReport')
}

// 地点グループカタログ
const PointGroupCatalog = () => {
  return import('@/pages/Advertiser/Operation/PointGroup/PointGroupCatalog')
}

// 地点グループ入稿
const PointGroupOperation = () => {
  return import(
    '@/pages/Advertiser/Operation/PointGroup/PointGroupOperation.vue'
  )
}

// 配信リストターゲティング
const InventoryListTargeting = () => {
  return import(
    '@/pages/Advertiser/InventoryListTargeting/InventoryListTargeting.vue'
  )
}

// IPアドレス List ターゲティング
const IPRangeListTargeting = () => {
  return import(
    '@/pages/Advertiser/IPRangeListTargeting/IPRangeListTargeting.vue'
  )
}

// Menu
const Menu = () => {
  return import('@/pages/Advertiser/Menu/Menu')
}

// キャンペーン管理
const InsertionOrders = () => {
  return import('@/pages/Advertiser/Operation/InsertionOrders')
}

// クリエイティブ管理
const Creative = () => {
  return import('@/pages/Advertiser/Operation/Creative')
}

// シミュレーション一覧
const Simulation = () => {
  return import('@/pages/Advertiser/Simulation/SimulationList')
}

// シミュレーション登録
const SimulationAdd = () => {
  return import('@/pages/Advertiser/Simulation/SimulationAdd')
}

// シミュレーション編集
const SimulationEdit = () => {
  return import('@/pages/Advertiser/Simulation/SimulationEdit')
}

export const advertiserRoutes = [
  // 予算進捗
  {
    path:
      '/agencies/:agencyId/advertisers/:advertiserId/budget_progress_reports',
    name: 'Budget Progress',
    component: BudgetProgress,
    meta: { requireAuth: true },
  },
  // 標準レポート
  {
    path: '/agencies/:agencyId/advertisers/:advertiserId/standard_reports',
    name: 'StandardReport',
    component: StandardReport,
    meta: { requireAuth: true },
  },
  // レポート出力
  {
    path: '/agencies/:agencyId/advertisers/:advertiserId/interval_reports',
    name: 'Report Interval Mail',
    component: IntervalReport,
    meta: { requireAuth: true },
  },
  // マップレポート申請
  {
    path: '/agencies/:agencyId/advertisers/:advertiserId/map_reports',
    name: 'Map Report Request',
    component: MapReportRequest,
    meta: { requireAuth: true },
  },
  // マップレポート
  {
    path:
      '/agencies/:agencyId/advertisers/:advertiserId/map_reports/:mapReportId',
    name: 'Map Report',
    component: MapReport,
    meta: { requireAuth: true },
  },
  // 地点グループ一覧
  {
    path: '/agencies/:agencyId/advertisers/:advertiserId/point_groups',
    name: 'Point Group Catalog',
    component: PointGroupCatalog,
    meta: { requireAuth: true },
  },
  // 地点グループ入稿編集(OEM配下)
  {
    path: '/system_owners/:system_owner_id/point_groups/:ownerProfileId',
    name: 'Point Group Operation Under OEM',
    component: PointGroupOperation,
    meta: { requireAuth: true },
  },
  // 地点グループ入稿編集(広告主配下)
  {
    path:
      '/agencies/:agencyId/advertisers/:advertiserId/point_groups/:ownerProfileId',
    name: 'Point Group Operation Under Adv',
    component: PointGroupOperation,
    meta: { requireAuth: true },
  },
  // 地点グループ入稿編集(案件配下)
  {
    path:
      '/agencies/:agencyId/advertisers/:advertiserId/insertion_orders/:insertionOrderId/point_groups/:ownerProfileId',
    name: 'Point Group Operation Under IO',
    component: PointGroupOperation,
    meta: { requireAuth: true },
  },
  // 配信リストターゲティング
  {
    path:
      '/agencies/:agencyId/advertisers/:advertiserId/inventory_list_targeting',
    name: 'Inventory List Targeting',
    component: InventoryListTargeting,
    meta: { requireAuth: true },
  },
  // IP range list ターゲティング
  {
    path:
      '/agencies/:agencyId/advertisers/:advertiserId/ip_address_list_targeting',
    name: 'IP Address List Targeting Advertiser',
    component: IPRangeListTargeting,
    meta: { requireAuth: true },
  },
  // メニュー
  {
    path: '/agencies/:agencyId/advertisers/:advertiserId/menu',
    name: 'Advertiser Menu',
    component: Menu,
    meta: { requireAuth: true },
  },
  // キャンペーン管理
  {
    path: '/agencies/:agencyId/advertisers/:advertiserId/insertion_orders',
    name: 'InsertionOrders',
    component: InsertionOrders,
    meta: { requireAuth: true },
  },
  // クリエイティブ管理
  {
    path: '/agencies/:agencyId/advertisers/:advertiserId/creatives',
    name: 'Creative',
    component: Creative,
    meta: { requireAuth: true },
  },
  // シミュレーション一覧
  {
    path: '/agencies/:agencyId/advertisers/:advertiserId/simulations',
    name: 'Simulation',
    component: Simulation,
    meta: { requireAuth: true },
  },
  // シミュレーション登録
  {
    path: '/agencies/:agencyId/advertisers/:advertiserId/simulations/add',
    name: 'SimulationAdd',
    component: SimulationAdd,
    meta: { requireAuth: true },
    props: {
      passedFrom: null,
    },
  },
  // シミュレーション編集
  {
    path:
      '/agencies/:agencyId/advertisers/:advertiserId/simulations/:simulationId/edit',
    name: 'SimulationEdit',
    component: SimulationEdit,
    meta: { requireAuth: true },
  },
]
